import { CalendarClock } from "lucide-react";
import { BaseAppointmentAction, AppointmentActionCategory, UserRole, AppointmentActionContext, AppointmentActionPayload, AppointmentActionResult } from "../core/base-action";
import { RESCHEDULABLE_STATUSES } from "@/lib/appointment-reschedule";
import { AppointmentApprovalService } from "@/services/appointment-approval.service";

export class RescheduleRequestAction extends BaseAppointmentAction {
    readonly config = {
        id: "reschedule_request",
        label: "Request Reschedule",
        description: "Request appointment reschedule from PMC",
        icon: CalendarClock,
        category: AppointmentActionCategory.SCHEDULING,
        permissions: {
            requiredRole: [UserRole.VENDOR],
            requiredStatuses: [...RESCHEDULABLE_STATUSES]
        },
        requiresDialog: true,
        variant: "default" as const
    };

    validatePayload(payload?: AppointmentActionPayload): string | null {
        if (!payload?.newDate) {
            return "New date is required for reschedule request";
        }
        if (!payload?.roomId) {
            return "Room ID is required for reschedule request";
        }
        return null;
    }

    getDialogComponent(): string {
        return "RescheduleRequestDialog";
    }

    async execute(
        context: AppointmentActionContext,
        payload?: AppointmentActionPayload
    ): Promise<AppointmentActionResult> {
        try {
            const { newDate, roomId } = payload || {};

            const approvalMessageId = await AppointmentApprovalService.sendApprovalRequest(roomId, { type: "reschedule", newDate });

            return {
                success: true,
                message: "Reschedule request sent for approval",
                requiresApproval: true,
                approvalMessageId
            };
        } catch (error: any) {
            return {
                success: false,
                message: error.message || "Failed to send reschedule request"
            };
        }
    }
}